export const CPU_CLOCKS = 1789773; // 1.789773 MHz
export const PPU_CLOCKS = CPU_CLOCKS * 3; // 5.369319 MHz
export const FRAME_RATE = 60; // 60 FPS
export const AUDIO_FREQ_ADJUST = 1.011;
export const CLOCKS_PER_FRAME = 29781; // 341*262/3